<div class="fullBox">
    <div class="flexContent items-center spacebetween mb-5">
        <h1>Angular container with comunication</h1>
        <button
            id="exampleAddNewOrderPlanner"
            type="button"
            class="main_btn"
            (click)="onOpenClick()">
            <i class="fas fa-plus"></i>
            Dodaj zlecenie
        </button>
    </div>
    <div class="boxContent">
        <h3>Angular ng-content placement for injecting AngularJs</h3>
        <!-- Placement of AngularJs component -->
        <ng-content></ng-content>
    </div>
</div>
